import React from 'react';
import DownloadFile from './DownloadFile';

export default function SocialContentAbonnement(props) {
    return (
        <DownloadFile filePath='/files/VM_Overeenkomst Content Abonnement_2022.pdf' fileName='Social content abonnement' />
    )
}